import axios from 'axios';

const api = axios.create({baseURL: 'https://wyd.raidhut.com.br/raid/'});

export {api};